import React from 'react';
import ForgotPasswordPage from '../pages/auth/forgot-password/ForgotPasswordPage'

function ForgotPassword() {

	return (
		<ForgotPasswordPage />
	);
}

export default ForgotPassword;
